<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="login-component h-screen flex w-full vx-row no-gutter items-center justify-center" id="page-login">
    <div class="background-illus">
      <img class="top-illus" src="@/assets/images/forget-password/Ellipse1.svg" alt="">
      <img class="bottom-illus" src="@/assets/images/forget-password/Ellipse2.svg" alt="">
    </div>
    <vs-popup title="" :active.sync="emailResend" class="text-center">
      <div class="mx-4">
        <img src="@/assets/images/pages/settings/loading.svg" class="mt-4"/>
        <p class="text-center">A verification email has been sent, please check your email account.</p>
        <vs-button @click="emailResend=false" class="md:w-1/4 w-full mt-6 md:mb-6 mb-4 rounded">Ok</vs-button>
      </div>
    </vs-popup>
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center box login">
            <div class="vx-col lg:block lg:w-1/2 md:p-16 p-10 pb-0">
              <a target="_blank" @click="$gtag.event('login-logo-image')" href="https://speakol.com/?ref=advertisers-signin">
               <img src="@/assets/images/speakol.svg" alt="login" class="signin-logo">
              </a>
              <div class="w-full text-center">
                <img src="@/assets/images/login/sign-up.svg"
                     class="sign-in-image md:w-full mx-auto sm:w-full pt-2 md:pt-10" alt="forget password">
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 d-theme-dark-bg rounded-md">
              <div class="login-tabs-container">
                <div class="vx-card__title">
                  <h4 class="mb-4 login-title">Sign In</h4>
                  <p class="mb-3">Welcome back, please login to your account.</p>
                </div>

                <vs-alert class="mt-5 block" color="danger" :active="this.$route.query.src === 'login_first'">
                  please login first, then accept your invitation.
                </vs-alert>
                <div>
                  <div class="space-y-8">
                    <div class="relative">
                      <vs-icon class="speakol-envelope-icon" icon="speakol-envelope" icon-pack="speakol"></vs-icon>
                      <input type="text"
                       id="login-email-input"
                       placeholder="Email"
                       name="email"
                       v-model="email"
                       v-validate="'required|email'"
                       class="w-full mt-5 mb-1 login-inputs"
                       :class="[
                        errors.first('email') || loginError === ERRORS.OTHER_ERROR || loginError === ERRORS.EMAIL_BLOCKED ? 'input_error' : '' ,
                        loginError === ERRORS.EMAIL_NOT_VERIFIED ? 'input_warning' : '' ,
                        loginError === ERRORS.PUBLISHER_EMAIL ? 'publisher_account' : ''
                       ]"
                       @keyup="clearLoginErrors"
                      />

                      <span class="text-danger text-sm" v-show="errors.has('email')">
                        {{ errors.first('email') }}
                      </span>

                      <span v-if="loginError === ERRORS.TOO_MANY_ATTEMPTS" class="text-danger text-sm block">
                              Too many login attempts. Please try again in {{ lockedSeconds }} seconds.
                      </span>
                      <span v-if="loginError === ERRORS.OTHER_ERROR" class="text-danger text-sm block">
                              The email or password you entered is incorrect
                      </span>
                      <span v-if="loginError === ERRORS.EMAIL_NOT_VERIFIED" class="text-warning text-sm block">
                              This email has not been verified yet. <a v-on:click.prevent="resendVerificationCode()"
                                                                       href="" class="text-warning underline font-bold">Resend verification link.</a>
                      </span>
                      <span v-if="loginError === ERRORS.PUBLISHER_EMAIL" class="text-primary text-sm block">
                              This email is registered as pulisher, please <a href="https://publishers.speakol.com"
                                                                              class="underline font-bold">sign in Here</a>
                      </span>
                      <span v-if="loginError === ERRORS.EMAIL_BLOCKED" class="text-danger text-sm block">
                              This email is blocked please contact your administrator.
                      </span>
                    </div>

                    <div class="relative">
                      <em
                        id="login-show-password-icon"
                        class="show-password-icon speakol icon icon-no-border"
                        :class="{ 'speakol-eye': show, 'speakol-hide': !show}"
                        @click="showPassword()"></em>


                      <vs-icon class="speakol-password-icon" icon="speakol-password" icon-pack="speakol"></vs-icon>
                      <input
                        id="login-password-input"
                        type="password"
                        :color="emailInputColor"
                        ref="password"
                        v-validate="'required'"
                        name="password"
                        placeholder="Password"
                        v-model="password"
                        class="login-inputs password-field w-full"
                        :class="{ input_error : errors.first('password') || errors.first('required') || errors.first('hasNumbers') || errors.first('minCharacters') || errors.first('hasLowerAndUpercases') || errors.first('specialCharacter') }"
                      />

                      <div class="">
                        <span class="mt-1 text-danger text-sm block">{{ errors.first('password') }}</span>
                        <span class="mt-1 text-danger text-sm block">{{ errors.first('required') }}</span>
                        <span class="mt-1 text-danger text-sm block">{{ errors.first('hasNumbers') }}</span>
                        <span class="mt-1 text-danger text-sm block">{{ errors.first('minCharacters') }}</span>
                        <span class="mt-1 text-danger text-sm block">{{ errors.first('hasLowerAndUpercases') }}</span>
                        <span class="mt-1 text-danger text-sm block">{{ errors.first('specialCharacter') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-wrap justify-between remember-me-parent">
                    <vs-checkbox @input="$gtag.event('Signin_Rememberme')" id="login-remember-me-checkbox" v-model="checkbox_remember_me" class="ml-0"><span class="ml-2">Remember Me</span></vs-checkbox>
                    <router-link @click.native="$gtag.event('Signin_Forget')" id="login-forget-password-button" to="/forget-password" class="forget-password">Forgot Password?</router-link>
                  </div>
                  <div class="justify-between space-y-4">
                    <vs-button id="login-sign-in-button" class="w-full speakol-background shadow-none rounded text-xl sign-in-button" v-on:click="login()">Sign In</vs-button>
                    <vs-button @click="handleSignUp" id="login-sign-up-button" class="w-full rounded text-xl sign-up-button" type="border">Sign Up</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

import get from 'lodash/get'
import first from 'lodash/first'

export default {
  data () {
    return {
      ERRORS: {
        TOO_MANY_ATTEMPTS: 'too_many_attempts',
        PUBLISHER_EMAIL: 'publisher_email',
        EMAIL_BLOCKED: 'email_blocked',
        EMAIL_NOT_VERIFIED: 'email_not_verified',
        EMAIL_NOT_EXIST: 'email_not_exist',
        OTHER_ERROR: 'error'
      },
      COLORS: {
        DANGER: 'danger',
        PRIMARY: 'primary',
        WARNING: 'warning',
        NO_COLOR: ''
      },
      HTTP_CODES: {
        TOO_MANY_REQUESTS: 429
      },
      email: '',
      password: '',
      checkbox_remember_me: false,
      loginError: '',
      show: false,
      emailResend: false,
      lockedSeconds: 0
    }
  },
  computed: {
    emailInputColor () {

      switch (this.loginError) {
      case this.ERRORS.EMAIL_NOT_VERIFIED:
        return this.COLORS.WARNING
      case this.ERRORS.TOO_MANY_ATTEMPTS:
      case this.ERRORS.EMAIL_BLOCKED:
      case this.ERRORS.OTHER_ERROR:
        return this.COLORS.DANGER
      case this.ERRORS.PUBLISHER_EMAIL:
        return this.COLORS.PRIMARY
      default:
        return this.COLORS.NO_COLOR

      }

    }
  },
  mounted () {
    // check for query verify=success for email verification pop up
    if (this.$route.query.verify === 'success') {
      this.emailVerificationSuccessPopUp()
    }
  },
  methods: {
    handleSignUp () {
      this.$gtag.event('Signin_Signupbutton')
      window.location.replace('/register')
    },
    clearLoginErrors () {
      this.loginError = ''
      this.lockedSeconds = 0
    },
    showPassword () {
      this.show = !this.show

      document.querySelectorAll('input[name=password]').forEach(element => {
        if (this.show) {
          element.type = 'text'
        } else {
          element.type = 'password'
        }
      })
    },
    async login () {
      try {
        this.$gtag.event('Signin_Button')
        await this.$validator.validateAll()
        if (!this.errors.any()) {
          const email = this.email
          const password = this.password
          await this.$store.dispatch('authentication/login', {email, password, remember: this.checkbox_remember_me})
          window.location.href = '/'
        }
      } catch (error) {

        if (this.is4xxError(error)) {
          if (this.isTooManyAttemptsError(error)) {
            this.renderTooManyAttemptsError(error)
          } else {
            this.renderOtherLoginErrors(error)
          }
        } else {
          this.sendExceptionToSentry(error)
        }

      }
    },


    is4xxError (error) {
      const statusCode = parseInt(get(error, 'response.status'))
      return statusCode && statusCode  < 500 && statusCode >= 400
    },

    isTooManyAttemptsError (error) {
      const statusCode = get(error, 'response.status', false)
      return statusCode && parseInt(statusCode) === this.HTTP_CODES.TOO_MANY_REQUESTS
    },


    renderTooManyAttemptsError (error) {
      const errorMessage = first(get(error, 'response.data.errors.email'))
      this.loginError = this.ERRORS.TOO_MANY_ATTEMPTS
      this.lockedSeconds = errorMessage.match(/\d/g) !== null ? parseInt(errorMessage.match(/\d/g).join('')) : 0
      this.countDownTimer = function () {
        if (this.lockedSeconds > 0 && this.loginError ===  this.ERRORS.TOO_MANY_ATTEMPTS) {
          setTimeout(() => {
            this.lockedSeconds -= 1
            this.countDownTimer()
          }, 1000)
        } else {
          this.loginError = ''
        }
      }
      this.countDownTimer()
    },


    renderOtherLoginErrors (error) {
      if (this.isEmailFieldError(error) && this.hasErrorCode(error)) {
        this.errorMessage = first(get(error, 'response.data.errors.email')).message
        this.loginError = first(get(error, 'response.data.errors.email')).code
      } else if (this.isEmailFieldError(error)) {
        this.errorMessage = first(get(error, 'response.data.errors.email'))
        this.loginError = this.ERRORS.OTHER_ERROR
      } else {
        this.sendExceptionToSentry(error)
      }
    },


    isEmailFieldError (error) {
      const emailError = get(error, 'response.data.errors.email')
      return typeof emailError === 'object' || Array.isArray(emailError)
    },

    hasErrorCode (error) {
      return typeof get(error, 'response.data.errors.email.[0].code') === 'string'
    },

    async resendVerificationCode () {
      await this.$store.dispatch('authentication/sendVerificationEmail', {
        email: this.email
      })
      this.emailResend = true
    },


    sendExceptionToSentry (error) {
      if (!window.axios) {
        return
      }
      
      window.axios.sendHandledSentryException(error)
    },

    emailVerificationSuccessPopUp () {
      this.$swal.mixin({
        imageUrl: require('@/assets/images/pages/register-confirmation-icon.svg'),
        imageWidth: 140,
        imageHeight: 140,
        imageAlt: 'icon',
        animation: false,
        width: 613,
        padding: '2em',
        text: 'Your email has been verified',
        showConfirmButton: true,
        showCancelButton: false,
        showCloseButton: false,
        customClass: {
          confirmButton: 'vs-component vs-button w-full md:w-7/12 md:mt-6 vs-button-primary shadow-none rounded vs-button-filled confirm-btn'
        },
        buttonsStyling: false
      }).fire()
    }
  }
}
</script>

<style lang="scss">
$speakolColor: #0092d7;

.forget-password {
  color: #0092d7 !important;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.1px;
}

.speakol-background {
  background: $speakolColor;
}

.login {
  color: #2c2c2c;
  border-radius: 0.375rem;
  overflow: hidden;

  input {
    border: 1px solid #d9d9d9;
    border-radius: 3px;

    &:focus {
      box-shadow: none;
    }
  }
}

.vs-input--placeholder {
  color: #dadada !important;
}

.con-text-validation {
  height: 0 !important;
}

.input-icon-validate {
  display: none;
}

.login-tabs-container {
  padding-top: 52px;
  padding-right: 52px;
  padding-bottom: 52px;
  // min-height: 505px;

  .login-title {
    color: $speakolColor;
    font-size: 24px;
  }

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}

.show-password-icon {
  position: absolute;
  font-weight: 100;
  top: 28%;
  right: 5%;
  z-index: 1;
  cursor: pointer;
  color: #d9d9d9;
  font-size: 20px;
}

.signin-logo {
  top: 11%;
  position: absolute;
}

@media only screen and (max-width: 768px) {
  .signin-logo {
    top: 2%;
    left: 9% !important;
    width: 25%;
  }

  .login-tabs-container {
    padding-top: 20px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
    padding-bottom: 20px !important;
  }

  .sign-in-image {
    margin-top: 40px;
    width: 300px;
  }

  .signin-logo {
    top: 3% !important;
  }
}

.bottom-illus {
  position: absolute;
  bottom: 0;
  right: 0;
}

.top-illus {
  position: absolute;
  top: 0;
  left: 0;
}

.input_error {
  border: 1px solid red !important;
}

.input_warning {
  border: 1px solid rgba(var(--vs-warning), 1) !important;
}

.publisher_account {
  border: 1px solid rgba(var(--vs-primary), 1) !important;
}

.speakol-envelope-icon {
  position: absolute;
  top: 27px;
  left: 10px;
  color: #d9d9d9;
}

.speakol-password-icon {
  position: absolute;
  top: 9px;
  left: 10px;
  color: #d9d9d9;
}

.login-inputs {
  height: 40px;
  text-indent: 40px;
  outline: none;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

.login-component {
  ::placeholder {
    color: #d9d9d9;
  }

  .vs-checkbox-primary input:checked + .vs-checkbox {
    background-color: #0092d7 !important;
    border: 2px solid #0092d7 !important;
  }
}

.sign-in-button {
  background-color: #0092d7 !important;
}

.sign-up-button {
  border: 1px solid #0092d7 !important;
  color: #0092d7 !important;
}

.remember-me-parent {
  margin-top: 16px;
  margin-bottom: 30px;
}
</style>
